import { Credentials } from '../models/Credentials';
import { LoginType } from '../models/LoginType';
import { Pleb } from '../models/Pleb';
import { FakeData } from './FakeData';
import { Repository } from './Repository';

export enum OtpReason {
  LOGIN = 'login',
  UPDATE = 'update',
}

export class AuthRepository {
  async sendOtp(loginType: LoginType, recipient: string, reason: OtpReason = OtpReason.LOGIN): Promise<string> {
    const path = 'v1/auth/otps';

    try {
      const response = await Repository.client.post(path, {
        recipient,
        reason: reason,
        provider: loginType === LoginType.EMAIL ? 'email' : 'nostr'
      });
      return response.data.data._id;
    } catch (err) {
      throw err;
    }
  }

  async verifyOtp(params: { otpId: string; otp: string }): Promise<{ credentials: Credentials; pleb: Pleb }> {
    const path = 'v1/auth/tokens';

    try {
      const response = await Repository.client.post(path, {
        provider: 'otp',
        reason: 'login',
        otpId: params.otpId,
        otp: params.otp
      });
      return {
        credentials: {
          accessToken: response.data.data.accessToken,
          refreshToken: response.data.data.refreshToken
        },
        pleb: Pleb.currentUserFromJson(response.data.data.user)
      }
    } catch (err) {
      throw err;
    }
  }

  async refreshToken(credentials: Credentials): Promise<Credentials> {
    const path = 'v1/auth/tokens';

    try {
      if(Repository.offlineMode) {
        return FakeData.getCredentials();
      }
      const response = await Repository.client.post(path, {
        provider: 'refreshToken',
        token: credentials.refreshToken
      });
      return {
        accessToken: response.data.data.accessToken,
        refreshToken: response.data.data.refreshToken
      };
    } catch (err) {
      throw err;
    }
  }

  async refreshGetStreamToken(): Promise<string> {
    const path = 'v1/auth/streamTokens';

    try {
      if(Repository.offlineMode) {
        return "fakeString";
      }
      const response = await Repository.client.post(path);
      return response.data.data.getStreamToken;
    } catch (err) {
      throw err;
    }
  }

  async loginWithNip07(event: object): Promise<{ credentials: Credentials; pleb: Pleb }> {
    const path = 'v1/auth/nostr/nip-07';

    try {
      const response = await Repository.client.post(path, {
        event
      });
      return {
        credentials: {
          accessToken: response.data.data.accessToken,
          refreshToken: response.data.data.refreshToken
        },
        pleb: Pleb.currentUserFromJson(response.data.data.user)
      }
    } catch (err) {
      throw err;
    }
  }
}

// Create a singleton instance
export const authRepository = new AuthRepository(); 